import commentsPinboardStore from 'store/comments-pinboard-store'

export interface ISetValues {
  skus?: string[]
  tags?: string[]
  brands?: string[]
}

/**
 * Command for client to set the pinboard with different filters based
 * on skus, brands, and/or tags.
 * @param resetValues - {skus, brands, tags}
 */
export function set(values: ISetValues) {
  commentsPinboardStore.skus = values.skus || []
  commentsPinboardStore.tags = values.tags || []
  commentsPinboardStore.brands = values.brands || []
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/comments-pinboard/comments-pinboard-commands.ts